import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'dynamic-error',
  templateUrl: './dynamic-success.component.html',
  styleUrls: ['./dynamic-success.component.scss'],
})
export class DynamicSuccessComponent implements OnInit {

  @Input() title: any;
  @Input() content: any;
  @Input() okButtonLabel: any;

  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {}

  dismiss(flag : boolean){
    this.modalController.dismiss({flag : flag});
  }

}
